import * as S from './Skeleton.styles'

type SkeletonProps = {
  width: number | string
  height?: number | string
} & React.HTMLAttributes<HTMLSpanElement>

const toCssLength = (value: number | string): string =>
  typeof value === 'number' ? `${value}px` : value

function Skeleton({ width, height = '1lh', style, ...rest }: SkeletonProps) {
  return (
    <S.Skeleton
      style={{
        width: toCssLength(width),
        height: toCssLength(height),
        ...style,
      }}
      {...rest}
    />
  )
}

export default Skeleton
